var headerWrapper = document.querySelectorAll('.header-wrapper');
var headerVisible = false;
var count = 0;
headerWrapper.forEach((header) => {
  const isHidden = header.offsetParent === null;
  if(isHidden) {
    count++;
  }
});
function loadCSS(file) {
  let link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = file;
  document.head.appendChild(link); 
}
if(count == 3){
  let brand = localStorage.getItem('theme');
  if(!brand) {
      brand = "starwars";
  }
  const headerClass = `header-${brand}`;
  document.querySelector("body").classList.add(`brand-${brand}`);
  window.brand = brand;
  document.querySelector(`.${headerClass}`).classList.add('active');
  var buttonSelector = document.querySelector('.cart__warnings .button');
  var brandSelector = document.querySelector(`[data-brand="${brand}"]`);
  if (brand == 'starwars') { 
    buttonSelector && buttonSelector.setAttribute("href", "/collections/meet-all-our-heroes");
    brandSelector.querySelector('.logo-store').classList.add('active');
  }
}

var show_password_buttons = document.querySelectorAll('.show-password');
show_password_buttons.forEach((button)=>{
  button.addEventListener('click', function(){
    var inputSelector = button.closest('.field').querySelector('input');
    if (inputSelector) {
      console.log(inputSelector,inputSelector.type);
      inputSelector.type = inputSelector.type === "password" ? "text" : "password";
    }
  });
})